module.exports = __webpack_public_path__ + "img/能效智控物联网云平台.39cdd91e.png";